import flatten from 'flat';
/* eslint-disable */
let messages = {};

if (COUNTRY === 'LV') {
  messages = {
    en: flatten(require('./lv/en.json')),
    lv: flatten(require('./lv/lv.json')),
    ru: flatten(require('./lv/ru.json')),
  };
}
if (COUNTRY === 'FI') {
  messages = {
    en: flatten(require('./fi/en.json')),
    fi: flatten(require('./fi/fi.json')),
  };
}
if (COUNTRY === 'MX') {
  messages = {
    en: flatten(require('./mx/en.json')),
    'es-MX': flatten(require('./mx/es-MX.json')),
  };
}
if (COUNTRY === 'ES') {
  messages = {
    en: flatten(require('./es/en.json')),
    es: flatten(require('./es/es.json')),
  };
}
if (COUNTRY === 'PL') {
  messages = {
    en: flatten(require('./pl/en.json')),
    pl: flatten(require('./pl/pl.json')),
  };
}
if (COUNTRY === 'AU') {
  messages = {
    'en-AU': flatten(require('./au/en-AU.json')),
  };
}
if (COUNTRY === 'EE') {
  if(REBRANDING) {
    messages = {
      en: flatten(require('./ee/en-creditea.json')),
      et: flatten(require('./ee/et-creditea.json')),
      ru: flatten(require('./ee/ru-creditea.json')),
    };
  } else {
    messages = {
      en: flatten(require('./ee/en.json')),
      et: flatten(require('./ee/et.json')),
      ru: flatten(require('./ee/ru.json')),
    };
  }
}
if (COUNTRY === 'LT') {
  messages = {
    en: flatten(require('./lt/en.json')),
    lt: flatten(require('./lt/lt.json')),
  };
}
if (COUNTRY === 'CZ') {
  messages = {
    en: flatten(require('./cz/en.json')),
    cs: flatten(require('./cz/cs.json')),
  };
}
/* eslint-enable */
export default messages;
